import { ColorAA } from "@bagel-web/components";
import { ChartOptions } from "chart.js/auto";
import Color from "color";

export const BAR_GAP_PADDING = 1;
export const EMPTY_SESSION_WIDTH = 0.1;

export const getDefaultChartOptions = ({
  isDarkMode,
}: {
  isDarkMode: boolean;
}): ChartOptions<"bar"> => {
  const textColor = isDarkMode ? ColorAA.lightBeige : ColorAA.lightBlack;
  const mutedColor = Color(isDarkMode ? ColorAA.beige : ColorAA.grey)
    .alpha(0.8)
    .hexa();
  const tooltipBg = isDarkMode ? ColorAA.lightBlack : ColorAA.white;
  const codePink = ColorAA.pink;

  return {
    animation: {
      duration: 0,
    },
    indexAxis: "y",
    maintainAspectRatio: false,
    scales: {
      x: {
        min: 1,
        title: {
          display: true,
          text: "Moment ID",
          color: mutedColor,
          font: {
            size: 14,
          },
        },
        position: "top",
        ticks: {
          display: true,
          color: mutedColor,
          stepSize: 1,
        },
        border: {
          display: false,
        },
        grid: {
          tickLength: 0,
          display: false,
        },
      },
      y: {
        stacked: true,
        ticks: {
          display: false,
        },
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        onClick: () => {
          /* no-op */
        },
        labels: {
          color: textColor,
          font: {
            size: 14,
          },
        },
      },
      tooltip: {
        enabled: true,
        yAlign: "center",
        displayColors: false,
        titleColor: codePink,
        bodyColor: textColor,
        backgroundColor: tooltipBg,
        titleFont: { size: 12, family: "monospace" },
        bodyFont: { size: 14 },
        callbacks: {
          label: (tooltipItem) => {
            const rawItem = tooltipItem.raw as [number, number];
            const start = rawItem[0];
            const end = rawItem[1];
            return end - start < 1
              ? `Origin Moment ID: ${start}`
              : `Moments: ${start} - ${end}`;
          },
        },
      },
    },
  };
};
